import { Controller } from "@hotwired/stimulus";
import { cspNonce } from '@rails/ujs';
import debounce from 'lodash.debounce';
import { csrfHeader } from '../shared/axiosExport';

export default class extends Controller {
  static targets = [ "input" ]
  static values = {
    url: String,
    method: 'post',
    root: String,
  }

  submit = () => {
    if(!this.hasUrlValue) return;
    fetch(this.getURL(), {
      method: this.getMethod(),
      cache: 'no-cache',
      redirect: 'follow',
      headers: {
        'Accept': 'application/javascript,text/javascript',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...csrfHeader,
      },
      ...this.getBody()
    })
      .then(this.processResponse)
  };

  debouncedSubmit = debounce(this.submit, 200);


  getMethod() {
    return this.methodValue.toString().toUpperCase();
  }

  getURL() {
    if(!this.isGETRequest()) {
      return this.urlValue;
    }
    const url = new URL(this.urlValue, this.getBase());

    const getInputParam = (input) => {
      if(!this.hasRootValue) return input.dataset.inputName;

      return `${this.rootValue}[${input.dataset.inputName}]`
    }

    this.inputTargets.reduce((obj, input) => {
      obj.set(getInputParam(input), input.value)
      return obj
    }, url.searchParams);

    return url.pathname + url.search;
  }

  getBase() {
    return this.urlValue.match(/\b(?:http|\/\/)\b/) ?
      undefined :
      window.location.origin;
  }

  isGETRequest() {
    return this.methodValue.toString().toLowerCase() === 'get';
  }

  getBody() {
    if(this.isGETRequest()) {
      return {}
    }

    return { body: JSON.stringify(this.processedData()) }
  }

  processResponse = (response) => {
    const type = response.headers.get('content-type');
    response.text().then(data => {
      if (typeof data === 'string' && typeof type === 'string') {
        if (type.match(/\b(?:java|ecma)script\b/)) {
          let script = document.createElement('script');
          script.setAttribute('nonce', cspNonce());
          script.text = data;
          document.head.appendChild(script).parentNode.removeChild(script);
        }
      }
    })
  };

  processedData() {
    let data = this.inputTargets.reduce((obj, input) => {
      return {
        ...obj,
        [input.dataset.inputName]: input.value,
      }
    }, {});
    if(this.hasRootValue) {
      data = { [this.rootValue]: {...data} };
    }
    return data;
  }
}
